<template>
  <div>
    <Breadcrumbs main="Diller" title="Liste" :links="breadLinks" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <c-table :tablefields="tablefields" :items="items">
                <template #cell(Islem)="row">
                  <b-btn-group>
                    <router-link
                      :to="`/dil/kayit/${row.item.EncId}`"
                      class="btn btn-success btn-xs"
                      >Düzelt</router-link
                    >
                    <b-button size="xs" @click="sil(row.item)" variant="danger"
                      >Sil</b-button
                    >
                  </b-btn-group>
                </template>
                <template #cell(Bayrak)="data">
                  <div
                    class="avatar"
                    v-if="data.value !== '' && data.value !== undefined"
                  >
                    <img
                      class="img-20 rounded-circle"
                      :src="data.value"
                      alt="#"
                    />
                  </div>
                </template>
                <template #cell(RehberAlisFiyati)="data">
                  <c-money-cell :fiyat="data.value" simge="TL"></c-money-cell>
                </template>
                <template #cell(RehberSatisFiyati)="data">
                  <c-money-cell :fiyat="data.value" simge="TL"></c-money-cell>
                </template>
                <template #cell(Aktif)="data">
                  <c-aktif-cell :isAktif="data.value"></c-aktif-cell>
                </template>
                <template #cell(KayitTarihi)="row">
                  <c-tarih-cell
                    :kayitTarihi="row.item.KayitTarihi"
                    :guncelTarih="row.item.GuncelTarih"
                    :rowKey="row.item.Id"
                  ></c-tarih-cell>
                </template>
              </c-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadLinks: [{ path: "/dil/kayit", title: "Ekle", icon: "plus" }],
      tablefields: [
        { key: "Islem", label: "İşlemler", sortable: false },
        { key: "Tanim", label: "Dil", sortable: true },
        { key: "Bayrak", label: "Bayrak", sortable: true },
        { key: "RehberAlisFiyati", label: "Rehber Alış", sortable: true },
        { key: "RehberSatisFiyati", label: "Rehber Satış", sortable: true },
        { key: "Aktif", label: "Aktif", sortable: true },
        { key: "Sira", label: "Sıra", sortable: true },
        { key: "KullaniciAdi", label: "Kullanıcı", sortable: true },
        { key: "KayitTarihi", label: "Kayıt Tarihi", sortable: true },
      ],

      items: [],
    };
  },
  mounted() {
    this.onList();
  },
  methods: {
    onList() {
      let vm = this;

      this.$connection.get("/diller", function (response) {
        vm.items = response;
      });
    },
    sil(item) {
      let vm = this;
      this.$alert.confirm(
        "Sil",
        "Dil kaydını silmek istediğinize emin misiniz?",
        "warning",
        function () {
          vm.$connection.delete("/diller/" + item.EncId, function (response) {
            vm.$alert.messageWithFunction(
              "Silindi",
              "Dil kaydı silindi.",
              "error",
              function () {
                vm.$listHelper.removeItem(vm.items, item);
              }
            );
          });
        }
      );
    },
  },
};
</script>
